import type { Address } from '../../types';

export const serializeBrAddress = (address: Address): string =>
  `${
    address.street +
    (address.number ? `, ${address.number}` : '') +
    (address.complement ? ` - ${address.complement}` : '')
  } - ${address.administrativeAreaLevel1} ${address.administrativeAreaLevel2}${
    address.zipCode ? ` | CEP: ${address.zipCode}` : ''
  }`;

export const invalidAddress = (address: Address) => {
  return !(
    address.street &&
    address.number &&
    address.neighborhood &&
    address.administrativeAreaLevel1 &&
    address.administrativeAreaLevel2 &&
    address.zipCode
  );
};

export const brStates = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];
